import React from 'react';
import { PageChat } from '../PageChat/PageChat';
import { DefaultLayout } from './DefaultLayout';
import { LayoutSegment } from './LayoutSegment';
import { PageChatBlocked } from '../PageChatBlocked/PageChatBlocked';
import { useIsBlocked } from '../../hooks/isBlocked';
var PageChatLayout = function () {
    var isBlocked = useIsBlocked(false)[0];
    return (React.createElement(DefaultLayout, null,
        React.createElement(LayoutSegment, { label: "main" }, isBlocked ? React.createElement(PageChatBlocked, null) : React.createElement(PageChat, null))));
};
export default PageChatLayout;
